export enum Colors {
  RED = "#D00000",
  YELLOW = "#FFBA08",
  BLUE = "#410FE6",
  PURPLE = "#E000C2",
  GREEN = "#2C6E49",
  BLACK = "#0F1A20"
}
